<template>
  <modal id="create-payment-method-modal">
    <template slot="title">Add Billing Card</template>
    <template slot="body">
          <payment-form card-setup @success="save" @error="onError"></payment-form>
    </template>
    <template slot="footer">
      <a href="#" @click="closeModal('create-card-modal')" class="btn btn-default">Cancel</a>
      <button class="btn btn-success" :data-secret="intent.client_secret" :disabled="isSubmitted" @click="checkout()">
        <span v-if="isSubmitted">
            <i class="fa fa-spin fa-spinner"></i> Saving
        </span>
        <span v-else>Save</span>
      </button>
    </template>
  </modal>
</template>
<script>
  export default {

      props: {
          user: {
              type: Object,
              required: true,
          },
          intent:{
              required: true,
          }
      },

      data() {
          return {
              isSubmitted: false,
          }
      },

      methods: {
          checkout() {
              this.isSubmitted = true;
              App.bus.$emit('add-payment-method-form', {secret: this.intent.client_secret, name: this.user.name});
          },

          save(paymentMethod) {
              axios.post(`/billing/${this.user.slug}`, {paymentMethod: paymentMethod}).then(response => {
                  Alert.withAction('Your Card was saved sucessfully!').then(() => {
                      this.refreshPage();
                  })
              }).catch(response => {
                  this.isSubmitted = false;
                  Alert.error(response.message)
              })
          },

          onError(errors){
              this.isSubmitted = false
          }
      },
  }
</script>
